<template>
    <div>
        <table class="text-center" id="tableToExport">
            <tbody><tr>
                <th>name</th>
                <th>email</th>
                <th>address</th>
                <th>postalZip</th>
                <th>numberrange</th>
                <th>text</th>
            </tr>
            <tr>
                <td>Lacota Higgins</td>
                <td>lacotahiggins7267@protonmail.com</td>
                <td>Ap #513-2444 Mi St.</td>
                <td>76067</td>
                <td>9</td>
                <td>imperdiet ornare. In faucibus. Morbi</td>
            </tr>
            <tr>
                <td>Lana Hendrix</td>
                <td>lanahendrix@icloud.org</td>
                <td>Ap #241-9775 Ac Ave</td>
                <td>72251</td>
                <td>2</td>
                <td>et netus et malesuada fames</td>
            </tr>
            <tr>
                <td>Hedda Gilliam</td>
                <td>heddagilliam6706@hotmail.ca</td>
                <td>751-9149 Commodo Rd.</td>
                <td>18483</td>
                <td>8</td>
                <td>lorem eu metus. In lorem.</td>
            </tr>
            <tr>
                <td>Ria Rutledge</td>
                <td>riarutledge9434@hotmail.com</td>
                <td>320-4233 Ut St.</td>
                <td>54610</td>
                <td>9</td>
                <td>dui. Suspendisse ac metus vitae</td>
            </tr>
            <tr>
                <td>Aretha Williams</td>
                <td>arethawilliams9404@yahoo.org</td>
                <td>P.O. Box 510, 5310 Non Rd.</td>
                <td>23219</td>
                <td>7</td>
                <td>nunc nulla vulputate dui, nec</td>
            </tr>
            <tr>
                <td>Galvin Lindsay</td>
                <td>galvinlindsay@hotmail.couk</td>
                <td>Ap #932-3736 Ut Road</td>
                <td>77831</td>
                <td>8</td>
                <td>fermentum vel, mauris. Integer sem</td>
            </tr>
            <tr>
                <td>Acton Ramirez</td>
                <td>actonramirez@icloud.com</td>
                <td>P.O. Box 686, 9062 Lobortis Rd.</td>
                <td>46688</td>
                <td>0</td>
                <td>ut ipsum ac mi eleifend</td>
            </tr>
            <tr>
                <td>Xenos Cherry</td>
                <td>xenoscherry3029@aol.couk</td>
                <td>P.O. Box 881, 5996 Sem, Rd.</td>
                <td>22751</td>
                <td>6</td>
                <td>blandit at, nisi. Cum sociis</td>
            </tr>
            <tr>
                <td>Gil Moon</td>
                <td>gilmoon@icloud.couk</td>
                <td>Ap #141-8807 Ac, Rd.</td>
                <td>73727</td>
                <td>3</td>
                <td>purus. Maecenas libero est, congue</td>
            </tr>
            <tr>
                <td>Ulysses Bryant</td>
                <td>ulyssesbryant@protonmail.org</td>
                <td>P.O. Box 927, 8973 Egestas. Rd.</td>
                <td>33166</td>
                <td>3</td>
                <td>odio semper cursus. Integer mollis.</td>
            </tr>
        </tbody></table>
        <b-button @click="exportXLSX">Export to Excel</b-button>
    </div>   
</template>

<script>
    //deliveryNotePosittionClaims - b-table - 
    // const worksheet = XLSX.utils.json_to_sheet(excelRows);
    // const workbook = XLSX.utils.book_new();

    // XLSX.utils.book_append_sheet(workbook, worksheet, "main");
    //XLSX.writeFile(workbook, "shit.xlsb");

    export default{
        props: {
            materials:{
                type: Array,
                default: null
            }
        },
        methods:{
            exportXLSX(){
                const wb = XLSX.utils.table_to_book(document.getElementById("tableToExport"));
                // const workbook = XLSX.utils.book_new
                // XLSX.utils.book_append_sheet()
                XLSX.writeFile(wb, "excel test file.xlsx");
            },
        }
        
    }
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>